import { z } from 'zod'
import type { NoContext } from '~/services/api/contracts/NoContext'
import { refineUniqueIds } from '~/services/api/contracts/refineUniqueIds'
import { ReplaceMenuCustomizationGroupLinkedItemsRequestSchema } from '~/services/api/generated'

const schema = ReplaceMenuCustomizationGroupLinkedItemsRequestSchema.extend({
  linked_items: z.array(
    ReplaceMenuCustomizationGroupLinkedItemsRequestSchema.shape.linked_items.element.extend({
      id: z.int().min(1)
    })
  )
}).strict()

export const MenuCustomizationGroupReplaceLinkedItems = (
  _context: NoContext
): z.ZodType<z.output<typeof schema>> =>
  schema.superRefine((value, issues) => {
    refineUniqueIds(value, issues, 'linked_items', 'id', 'linked_items_duplicate')
  })
